import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  status: null,
  message: null,
  data: null,
};

const rawAuditSheetsReducer = createReducer(initialState, {
  RAW_AUDIT_SHEET_REQ: (state) => {
    state.loading = true;
    state.data = null;
  },
  RAW_AUDIT_SHEET_SUC: (state, actions) => {
    const payload = actions.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data;
  },
  RAW_AUDIT_SHEET_ERROR: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
  },
});

export default rawAuditSheetsReducer;
